export const deploymentQueryKeys = {
    pageAll: (scenarioId: string) => ['page-scenario-deploys', scenarioId],
    diffAll: (scenarioId: string) => ['scenario-deploy-diff', scenarioId],
} as const;
